import { render, staticRenderFns } from "./EbkVedomst.vue?vue&type=template&id=dc48859a&scoped=true&"
import script from "./EbkVedomst.vue?vue&type=script&lang=js&"
export * from "./EbkVedomst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc48859a",
  null
  
)

export default component.exports